import React from "react";
import "./ComingSoon.scss"; // Add some styles
import character from "../../Images/output.jpg"; // Replace with actual image path

const ComingSoon = () => {
  return (
    <div className="coming-soon">
      <div>
        <img
          src={character}
          alt="Cartoon Character"
          className="character-animation"
        />
      </div>
      <h1>Coming Soon</h1>
      <p>This module is under development. Stay tuned!</p>
    </div>
  );
};

export default ComingSoon;
